import { connect } from 'react-redux';
import { IState } from '../../reducers';
import { fetchArchiveEventItemsAction, fetchArchivePageNewsItemsByCategoryAction, fetchEventCategoriesAction } from './actions/fetchArchivePageEventItems';

import {EventsArchivePage} from './eventsArchivePage';

const mapStateToProps = (state: IState, ownProps: any) => ({
    categoriesFilter: ownProps.params.categories,
    eventItemDto: state.eventsAndNewsItems.eventItemDto,
    newsCategories: state.eventsAndNewsItems.eventCategories
});

const mapDispatchToProps = (dispatch: any) => ({
    fetchArchiveEventItems: (query?: object) => dispatch(fetchArchiveEventItemsAction(query)),
    fetchArchiveEventItemsByCategory: (categories: string, query?: object) => dispatch(fetchArchivePageNewsItemsByCategoryAction(categories, query)),
    fetchEventCategories: () => dispatch(fetchEventCategoriesAction())
});

export const EventsArchivePageContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(EventsArchivePage);


// WEBPACK FOOTER //
// ./src/components/eventsArchivePage/eventsArchivePageContainer.tsx